import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  Typography,
  Box,
  Button,
  Paper,
  Divider,
  Checkbox,
  FormControlLabel,
  Slider,
  IconButton,
  TextField,
  CircularProgress,
  Grid as Grid2,
  Modal,
  List,
  ListItem,
  ListItemText,
  InputAdornment,
} from "@mui/material";
import {
  DirectionsBus as DirectionsBusIcon,
  LocationOn as LocationOnIcon,
  SwapHoriz as SwapHorizIcon,
  CalendarToday as CalendarTodayIcon,
  ArrowLeft as ArrowLeftIcon,
  ArrowRight as ArrowRightIcon,
  MoreVert as MoreIcon,
  ElectricalServices as ElectricalServicesIcon,
  Logout as LogoutIcon,
  Tungsten as TungstenIcon,
  MedicalServices as MedicalServicesIcon,
  Hardware as HardwareIcon,
  GpsFixed as GpsFixedIcon,
  MultipleStop as MultipleStopIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import axios from "axios";
import Autocomplete from "@mui/material/Autocomplete";
import { toast, ToastContainer } from "react-toastify";
import debounce from "lodash.debounce";
import SearchIcon from '@mui/icons-material/Search';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import UserDetailsForm from "./UserDetailsForm";
import BusSeatLayout from "./BusSeatLayout";

const BusResults = () => {
  const location = useLocation();
  const { buses: initialBuses, fromStation, toStation, selectedDate, Origin, Destination, TraceId, resultIndex, currentPage: initialPage = 1,
    totalPages: initialTotalPages = 1,
    totalItems: initialTotalItems = 0,sessionId } = location.state || {
    buses: [],
    fromStation: null,
    toStation: null,
    selectedDate: new Date(),
    currentPage: 1,
    totalPages: 1,
    totalItems: 0
  };

  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searching, setSearching] = useState(false);
  const [currentFromStation, setCurrentFromStation] = useState(fromStation);
  const [currentToStation, setCurrentToStation] = useState(toStation);
  const [currentSelectedDate, setCurrentSelectedDate] = useState(selectedDate);
  const [buses, setBuses] = useState(initialBuses);
  const [origin, setOrigin] = useState("");
  const [destination, setDestination] = useState("");
  const [activeDropdowns, setActiveDropdowns] = useState({});
  const [traceId, setTraceId] = useState("");
  const [seatLayouts, setSeatLayouts] = useState({});
  const [openSeatLayouts, setOpenSeatLayouts] = useState({});
  const [loading2, setLoading2] = useState({});
  const [selectedSeats, setSelectedSeats] = useState({});
  const [boardingPoints,setBoardingPoints]=useState([]);
  const [droppingPoints,setDroppingPoints]=useState([]);
  const [selectedBoardingPoint, setSelectedBoardingPoint] = useState(null);
const [selectedDroppingPoint, setSelectedDroppingPoint] = useState(null);
const [searchBoarding, setSearchBoarding] = useState('');
const [searchDropping, setSearchDropping] = useState('');
const [showBoardingModal, setShowBoardingModal] = useState(false);
const [showDroppingModal, setShowDroppingModal] = useState(false);
const [showBookingForm, setShowBookingForm] = useState(false);
const[busIndexxxx,setBusIndexxxx]=useState('');
const [loadingMore, setLoadingMore] = useState(false);

const busesContainerRef = useRef(null);

const [isFetching, setIsFetching] = useState(false);
const [currentPage, setCurrentPage] = useState(initialPage);
const [totalPages, setTotalPages] = useState(initialTotalPages);
const [totalItems, setTotalItems] = useState(initialTotalItems);
const [allBusesLoaded, setAllBusesLoaded] = useState(initialPage >= initialTotalPages);
const [isScrollingUp, setIsScrollingUp] = useState(false);
const [prevScrollPos, setPrevScrollPos] = useState(0);
const [isLoading, setIsLoading] = useState(false);

const busesPerPage = 20;

  const navigate = useNavigate();
  const offersRef = useRef(null);
  const dateSelectorRef = useRef(null);

  console.log("Current Selected Date ",currentSelectedDate)
 

  const fetchCities = async (searchTerm) => {
    const jwtToken = sessionStorage.getItem("jwtToken");
    try {
      setLoading(true);
      const response = await axios.get(
        `https://api.ipaisa.co.in/myapp/bus/citylist/search?searchTerm=${searchTerm}&type=origin`,
        { headers: { Authorization: `Bearer ${jwtToken}` } }
      );

      if (response.data && response.data.BusCities) {
        setCities(response.data.BusCities);
      } else {
        console.error("Invalid city list format:", response.data);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCities();

  }, []);


  const handleSwapStations = () => {
    const temp = currentFromStation;
    setCurrentFromStation(currentToStation);
    setCurrentToStation(temp);
  };

  // const searchBuses = async () => {
  //   if (!currentFromStation || !currentToStation || !currentSelectedDate) {
  //     toast.error("Please select From City, To City, and Date of Journey.");
  //     return;
  //   }

  //   const requestBody = {
  //     dateOfJourney: currentSelectedDate,
  //     originId: currentFromStation.CityId,
  //     destinationId: currentToStation.CityId,
  //   };

  //   try {
  //     setSearching(true);
  //     const jwtToken = sessionStorage.getItem("jwtToken");
  //     console.log("hellllooooooo")
  //     const response = await axios.post(
  //       "https://api.ipaisa.co.in/myapp/bus/search",
  //       requestBody,
  //       { headers: { Authorization: `Bearer ${jwtToken}` } }
  //     );

  //     console.log("Yashhhhhh",response)
  //     if (response.data.data?.BusResults) {
  //       console.log("Sahillllllllllll",response.data.data?.BusResults?.content)
  //       setBuses(response.data.data?.BusResults?.content);
  //       setOrigin(response.data?.Origin);
  //       setDestination(response.data?.Destination);
  //       setTraceId(response.data?.data?.TraceId);
  //     } else {
  //       const errorMessage = response.data.Error?.ErrorMessage || "No buses available for the selected route.";
  //       toast.warning(errorMessage);
  //       setBuses([]);
  //       setOrigin("");
  //       setDestination("");
  //     }
  //   } catch (error) {
  //     console.error("Error searching for buses:", error);
  //     toast.error("Failed to search buses.");
  //     setBuses([]);
  //     setOrigin("");
  //     setDestination("");
  //   } finally {
  //     setSearching(false);
  //   }
  // };
  const searchBuses = async (isLoadMore = false) => {
    if (isLoading) return;
  
    // Clear old results for a new search
    if (!isLoadMore) {
      setBuses([]);
   
    }
  
    try {
      setIsLoading(true);
      const jwtToken = sessionStorage.getItem("jwtToken");
  
      const response = await axios.post(
        "https://api.ipaisa.co.in/myapp/bus/search",
        {
          dateOfJourney: currentSelectedDate,
          originId: currentFromStation.CityId,
          destinationId: currentToStation.CityId,
        },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            'Session-ID': sessionId,
          },
          params: {
            page: isLoadMore ? currentPage + 1 : 1,
            size: busesPerPage,
          }
        }
      );
  
      if (response.data.data?.BusResults) {
        const busResults = response.data.data.BusResults;
  
        // Update buses based on isLoadMore
        if (!isLoadMore) {
          setBuses(busResults.content);
        } else {
          setBuses(prev => [...prev, ...busResults.content]);
        }
  
        setOrigin(response.data?.Origin);
        setDestination(response.data?.Destination);
        setTraceId(response.data?.data?.TraceId);
        setCurrentPage(busResults.currentPage);
        setTotalPages(busResults.totalPages);
        setTotalItems(busResults.totalItems);
      }
    } catch (error) {
      console.error("Error searching for buses:", error);
      toast.error("Failed to load buses.");
    } finally {
      setIsLoading(false);
    }
  };
  

  // Scroll handler for pagination
  useEffect(() => {
    const busesContainer = busesContainerRef.current;
    
    const handleScroll = () => {
      const currentScrollPos = busesContainer.scrollTop;
      setIsScrollingUp(currentScrollPos < prevScrollPos);
      setPrevScrollPos(currentScrollPos);
      
      // Scroll to top - load previous page
      if (currentScrollPos === 0 && currentPage > 1 && !isLoading) {
        loadPreviousPage();
      }
      
      // Scroll to bottom - load next page
      const bottomThreshold = busesContainer.scrollHeight - busesContainer.clientHeight - 100;
      if (currentScrollPos >= bottomThreshold && currentPage < totalPages && !isLoading) {
        loadNextPage();
      }
    };

    const loadNextPage = () => {
      if (currentPage < totalPages) {
        searchBuses(currentPage + 1, true);
      }
    };

    const loadPreviousPage = () => {
      if (currentPage > 1) {
        searchBuses(currentPage - 1, false);
        // Scroll to bottom of the previous page's content
        setTimeout(() => {
          busesContainer.scrollTop = busesContainer.scrollHeight - busesContainer.clientHeight - 100;
        }, 100);
      }
    };

    if (busesContainer) {
      busesContainer.addEventListener('scroll', handleScroll);
      return () => busesContainer.removeEventListener('scroll', handleScroll);
    }
  }, [currentPage, totalPages, isLoading, prevScrollPos]);
  
  // Update your scroll handler
  // useEffect(() => {
  //   const handleScroll = debounce(() => {
  //     if (busesContainerRef.current && !isFetching && !allBusesLoaded) {
  //       const { scrollTop, scrollHeight, clientHeight } = busesContainerRef.current;
  //       // Trigger when scrolled to bottom of the container
  //       if (scrollTop + clientHeight >= scrollHeight - 20) {
  //         searchBuses(currentPage + 1, true);
  //       }
  //     }
  //   }, 200);
  
  //   const container = busesContainerRef.current;
  //   if (container) {
  //     container.addEventListener('scroll', handleScroll);
  //     return () => container.removeEventListener('scroll', handleScroll);
  //   }
  // }, [currentPage, isFetching, allBusesLoaded]);

  const handleDateChange = (date) => {

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    setCurrentSelectedDate(`${year}-${month}-${day}`);
    console.log("Date Twoooo",currentSelectedDate)
    searchBuses(0,true); // This will trigger a new search with the updated date
  };
  
  const handleSelectSeats = async (resultIndex, busIndex) => {
    // Close all other seat layouts first
    setOpenSeatLayouts(prev => {
      const newState = {};
      for (const key in prev) {
        newState[key] = false;
      }
      // Toggle the clicked bus's seat layout
      newState[busIndex] = !prev[busIndex];
      return newState;
    });
  
    // If we're opening the seat layout, load the data
    if (!openSeatLayouts[busIndex]) {
      setLoading2((prev) => ({ ...prev, [busIndex]: true }));
  
      const jwtToken = sessionStorage.getItem("jwtToken");
      const requestBody = {
        traceId: traceId || TraceId,
        resultIndex: resultIndex,
      };
  
      try {
        const response = await axios.post(
          "https://api.ipaisa.co.in/myapp/bus/seatlayout",
          requestBody,
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
              "Content-Type": "application/json",
            },
          }
        );
  
        if (response.status === 200) {
          setSeatLayouts((prev) => ({
            ...prev,
            [busIndex]: response.data.data.GetBusSeatLayOutResult.SeatLayoutDetails,
          }));
  
          callboardingandrpping(resultIndex, busIndex, traceId, TraceId);
        }
      } catch (error) {
        console.error("Error calling API:", error);
        toast.error("Failed to fetch seat layout.");
      } finally {
        setLoading2((prev) => ({ ...prev, [busIndex]: false }));
      }
    }
  };

  const callboardingandrpping = async (resultIndex,busIndex,traceId,TraceId) =>
  {
    const jwtToken = sessionStorage.getItem("jwtToken");
    const requestBody = {
      traceId: traceId || TraceId,
      resultIndex: resultIndex,
    };

    try {
      console.log("Hello Kamran In Boarding And Dropping Points ")
      const response = await axios.post(
        "https://api.ipaisa.co.in/myapp/bus/boarding",
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data) {
        throw new Error("API request failed");
      }

      setBoardingPoints(response.data.GetBusRouteDetailResult.BoardingPointsDetails || []);
      setDroppingPoints(response.data.GetBusRouteDetailResult.DroppingPointsDetails || []);
      setBusIndexxxx(busIndex);
      console.log("droppping Points ",droppingPoints)
      console.log("Boarding Points  ",boardingPoints)
    } catch (error) {
      console.error("Error calling API:", error);
      toast.error("Failed to fetch seat layout.");
      setBoardingPoints([]);
      setDroppingPoints([]);
    } finally {
      setLoading2((prev) => ({ ...prev, [busIndex]: false }));
    }

  };

  // const handleSeatSelection = (busIndex, seat) => {
  //   toast.info("Hello sahil")
  //   console.log("Sahillllllllllllll",seat)
  //   setSelectedSeats((prev) => {
  //     const currentSelected = prev[busIndex] || [];
  //     const isSelected = currentSelected.some(s => s.SeatIndex === seat.SeatIndex);
      
  //     if (isSelected) {
  //       return {
  //         ...prev,
  //         [busIndex]: currentSelected.filter(s => s.SeatIndex !== seat.SeatIndex)
  //       };
  //     } else {
  //       // Add IsUpper flag based on seat position
  //       const seatWithDeck = {
  //         ...seat,
  //         IsUpper: seat.SeatIndex >= 11 // Seats 11-20 are upper deck
  //       };
        
  //       // Limit to 6 seats
  //       if (currentSelected.length >= 6) {
  //         toast.warning("Maximum 6 seats allowed per booking");
  //         return prev;
  //       }
        
  //       return {
  //         ...prev,
  //         [busIndex]: [...currentSelected, seatWithDeck]
  //       };
  //     }
  //   });
  // };


//   const handleSeatSelection = (busIndex, seat) => {
//   // Display a toast message
//   toast.info("Hello sahil");

//   // Log the selected seat for debugging
//   console.log("Sahillllllllllllll", seat);

//   // Update the selectedSeats state
//   setSelectedSeats((prev) => {
//     // Get the currently selected seats for the specific bus
//     const currentSelected = prev[busIndex] || [];

//     // Check if the seat is already selected
//     const isSelected = currentSelected.some(s => s.SeatIndex === seat.SeatIndex);

//     if (isSelected) {
//       // If the seat is already selected, remove it from the list
//       return {
//         ...prev,
//         [busIndex]: currentSelected.filter(s => s.SeatIndex !== seat.SeatIndex)
//       };
//     } else {
//       // Add IsUpper flag based on seat position (seats 11-20 are upper deck)
//       const seatWithDeck = {
//         ...seat,
//         IsUpper: seat.SeatIndex >= 11
//       };

//       // Limit to 6 seats per booking
//       if (currentSelected.length >= 6) {
//         toast.warning("Maximum 6 seats allowed per booking");
//         return prev;
//       }

//       // Add the seat to the list of selected seats
//       return {
//         ...prev,
//         [busIndex]: [...currentSelected, seatWithDeck]
//       };
//     }
//   });
// };

const handleSeatSelection = (busIndex, seat) => {
  console.log("Hellloooo")
  setSelectedSeats((prev) => {
    const currentSelected = prev[busIndex] || [];
    const isSelected = currentSelected.some((s) => s.SeatIndex === seat.SeatIndex);

    if (isSelected) {
      // Deselect the seat
      return {
        ...prev,
        [busIndex]: currentSelected.filter((s) => s.SeatIndex !== seat.SeatIndex),
      };
    } else {
      // Select the seat (limit to 6 seats)
      if (currentSelected.length >= 6) {
        toast.warning("Maximum 6 seats allowed per booking.");
        return prev;
      }
      return {
        ...prev,
        [busIndex]: [...currentSelected, seat],
      };
    }
  });
  console.log("Sahillllllllllllllllllllllllllllllllllllll",selectedSeats)
};



  const renderBoardingDroppingPoints = () => {
    // Format time to 24-hour format
    const formatTime24hr = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleTimeString('en-US', {
            hour12: false,
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const seatsArray = Array.isArray(selectedSeats) ? selectedSeats : [];
    console.log("Yashhhhh",seatsArray)
  
    // Calculate total amount safely
    const calculateTotalAmount = (seats) => {
      if (!Array.isArray(seats)) return 0;
      return seats.reduce((total, seat) => {
        // Ensure seat has SeatFare property
        const fare = typeof seat.SeatFare === 'number' ? seat.SeatFare : 0;
        return total + fare;
      }, 0);
    };

    const filteredBoarding = (boardingPoints || []).filter(point => 
      point?.CityPointName?.toLowerCase().includes(searchBoarding.toLowerCase()) || 
      point?.CityPointLocation?.toLowerCase().includes(searchBoarding.toLowerCase())
    );
  
    const filteredDropping = (droppingPoints || [])?.filter(point => 
      point?.CityPointName?.toLowerCase().includes(searchDropping.toLowerCase()) || 
      point?.CityPointLocation?.toLowerCase().includes(searchDropping.toLowerCase())
    );

    
        // Function to handle continue click
        const handleContinueClick = (busIndex) => {
          const bookingData = {
            selectedSeats: selectedSeats[busIndex] || [], // Send the full seat objects
            selectedBoardingPoint,
            selectedDroppingPoint,
            resultIndex: buses[busIndex]?.ResultIndex,
            traceId: traceId || TraceId,
            totalAmount: calculateTotalAmount(selectedSeats[busIndex] || []),
            boardingPoints,
            droppingPoints,
            busDetails: buses[busIndex],
          };
        
          navigate("/UserBookingForm", { state: bookingData });
        };
        
  
    return (
      <Box>
        {/* Boarding Point Section - Always Visible */}
        <Paper sx={{ mb: 3, padding:'1rem', boxShadow:'none', borderRadius:'12px' }}>          
          {selectedBoardingPoint ? (
            <Box>
              <Typography sx={{ color:'#666', fontSize:'14px' }}>
                Boarding Point
              </Typography>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                {selectedBoardingPoint.CityPointName}
              </Typography>
              <Typography variant="body2">
                {formatTime24hr(selectedBoardingPoint.CityPointTime)}
              </Typography>
              <Typography variant="body2">
                {selectedBoardingPoint.CityPointLocation}
              </Typography>
              <Typography variant="body2">
                {selectedBoardingPoint.CityPointLandmark}
              </Typography>
              <Typography variant="body2">
                {selectedBoardingPoint.CityPointContactNumber}
              </Typography>
              <Typography variant="body2">
                {selectedBoardingPoint.CityPointAddress}
              </Typography>
              <Button 
                variant="outlined" 
                size="small" 
                sx={{ mt: 1 }}
                onClick={() => {
                  setSelectedBoardingPoint(null);
                  setSearchBoarding('');
                }}
              >
                Change
              </Button>
            </Box>
          ) : (
            <Box>
              <TextField
                fullWidth
                placeholder="Search boarding points..."
                variant="standard"
                size="small"
                sx={{ mb: 2 }}
                value={searchBoarding}
                onChange={(e) => setSearchBoarding(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
              
              <List sx={{ maxHeight: 200, overflow: 'auto' }}>
                {filteredBoarding?.map((point) => (
                  <ListItem 
                    key={point.CityPointIndex}
                    button
                    onClick={() => setSelectedBoardingPoint(point)}
                    sx={{
                      borderBottom: 1,
                      borderColor: 'divider',
                      cursor:'pointer'
                    }}
                  >
                    <Checkbox
                      edge="start"
                      checked={selectedBoardingPoint?.CityPointIndex === point.CityPointIndex}
                      tabIndex={-1}
                      disableRipple
                    />
                    <ListItemText
                      primary={
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                          {point.CityPointName}
                        </Typography>
                      }
                      secondary={
                        <>
                          <Typography component="span" variant="body2" display="block">
                            {formatTime24hr(point.CityPointTime)}
                          </Typography>
                          <Typography component="span" variant="body2" display="block">
                            {point.CityPointLocation}
                          </Typography>
                          <Typography component="span" variant="body2" display="block">
                            {point.CityPointLandmark}
                          </Typography>
                          <Typography component="span" variant="body2" display="block">
                            {point.CityPointContactNumber}
                          </Typography>
                          <Typography component="span" variant="body2" display="block">
                            {point.CityPointAddress}
                          </Typography>
                        </>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          )}
        </Paper>

        {/* Dropping Point Section - Only shows after boarding is selected */}
        {selectedBoardingPoint && (
          <Paper sx={{ mb: 3, padding:'1rem', boxShadow:'none', borderRadius:'12px' }}>          
            <Box>            
              {selectedDroppingPoint ? (
                <Box>
                  <Typography sx={{ color:'#666', fontSize:'14px' }}>
                    Dropping Point
                  </Typography>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                    {selectedDroppingPoint.CityPointName}
                  </Typography>
                  <Typography variant="body2">
                    {formatTime24hr(selectedDroppingPoint.CityPointTime)}
                  </Typography>
                  <Typography variant="body2">
                    {selectedDroppingPoint.CityPointLocation}
                  </Typography>
                  <Button 
                    variant="outlined" 
                    size="small" 
                    sx={{ mt: 1 }}
                    onClick={() => {
                      setSelectedDroppingPoint(null);
                      setSearchDropping('');
                    }}
                  >
                    Change
                  </Button>
                </Box>
              ) : (
                <Box>
                  <TextField
                    fullWidth
                    placeholder="Search dropping points..."
                    variant="standard"
                    size="small"
                    sx={{ mb: 2 }}
                    value={searchDropping}
                    onChange={(e) => setSearchDropping(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  
                  <List sx={{ maxHeight: 200, overflow: 'auto' }}>
                    {filteredDropping?.map((point) => (
                      <ListItem 
                        key={point.CityPointIndex}
                        button
                        onClick={() => setSelectedDroppingPoint(point)}
                        sx={{
                          borderBottom: 1,
                          borderColor: 'divider',
                          cursor:'pointer'
                        }}
                      >
                        <Checkbox
                          edge="start"
                          checked={selectedDroppingPoint?.CityPointIndex === point.CityPointIndex}
                          tabIndex={-1}
                          disableRipple
                        />
                        <ListItemText
                          primary={
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                              {point.CityPointName}
                            </Typography>
                          }
                          secondary={
                            <>
                              <Typography component="span" variant="body2" display="block">
                                {formatTime24hr(point.CityPointTime)}
                              </Typography>
                              <Typography component="span" variant="body2" display="block">
                                {point.CityPointLocation}
                              </Typography>
                            </>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                </Box>
              )}
            </Box>
          </Paper>
        )}
  
        {/* Continue Button */}
        {selectedBoardingPoint && selectedDroppingPoint && (
  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
    <Button 
      variant="contained" 
      disabled={selectedSeats?.length === 0}
      onClick={() => handleContinueClick(busIndexxxx)}
      sx={{ 
        width: '100%',
        maxWidth: 400,
        py: 1.5,
        fontSize: '1rem'
      }}
    >
      Continue
    </Button>
  </Box>
)}
      </Box>
    );
};
  
 
const renderSeatLayout = (busIndex) => {
  const layout = seatLayouts[busIndex];
  const currentSelected = selectedSeats[busIndex] || [];

  if (!layout || !layout.SeatLayout || !layout.SeatLayout.SeatDetails) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="body1">No seat layout available</Typography>
      </Box>
    );
  }

  return (
    <BusSeatLayout
      seatData={layout}
      onSeatSelect={(seat) => handleSeatSelection(busIndex, seat)}
      selectedSeats={currentSelected}
    />
  );
};

const renderSeatSelectionAndPoints = (busIndex) => {
  const layout = seatLayouts[busIndex];
  const currentSelected = selectedSeats[busIndex] || [];
  const maxSeatsReached = currentSelected.length >= 6;

  return (
    <Box sx={{ 
      backgroundColor: '#f8f8f8', 
      padding: '1rem', 
      borderRadius: '12px',
      display: 'flex',
      flexDirection: 'column',
      minHeight: '600px'
    }}>
      <Grid sx={{display: 'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'2%'}}>
        <Typography gutterBottom sx={{fontWeight:'bold', fontSize:'16px'}}>
          {layout?.AvailableSeats || 0} Seats Available
          <Typography sx={{fontSize:'14px', color:'#666'}}>
            Click on seat to select/deselect
          </Typography>
          {maxSeatsReached && (
            <Typography variant="caption" color="error" sx={{ ml: 1 }}>
              (Max 6 seats reached)
            </Typography>
          )}
        </Typography>
      </Grid>
      
      <Grid container spacing={3} sx={{ flex: 1 }}>
        {/* Left Column - Seat Layout */}
        <Grid item xs={12} md={7} sx={{ 
            display: 'flex',
            flexDirection: 'column'
        }}>
            {renderSeatLayout(busIndex)}
        </Grid>
  
        {/* Right Column - Boarding/Dropping Points */}
        <Grid item xs={12} md={5} sx={{ 
            display: 'flex',
            flexDirection: 'column'
        }}>
            {renderBoardingDroppingPoints()}
        </Grid>
      </Grid>
    </Box>
  );
};
  
  const calculateJourneyDuration = (departureTime, arrivalTime) => {
    const departure = new Date(departureTime);
    const arrival = new Date(arrivalTime);
    const durationInMilliseconds = arrival - departure;
    const durationInHours = durationInMilliseconds / (1000 * 60 * 60);
    return `${durationInHours.toFixed(1)} hrs`;
  };

  const generateDates = () => {
    const dates = [];
    const today = new Date();
    for (let i = 0; i < 15; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      dates.push(date);
    }
    return dates;
  };

  const debouncedFetchCities = debounce((searchTerm) => {
    fetchCities(searchTerm);
  }, 300);

  const onInputChange = (event, newValue) => {
    if (newValue) {
      debouncedFetchCities(newValue);
    }
  };

  const scrollOffers = (direction) => {
    if (offersRef.current) {
      offersRef.current.scrollBy({ left: direction === "left" ? -200 : 200, behavior: "smooth" });
    }
  };

  const scrollDateSelector = (direction) => {
    if (dateSelectorRef.current) {
      dateSelectorRef.current.scrollBy({ left: direction === "left" ? -200 : 200, behavior: "smooth" });
    }
  };

  const filterSectionStyle = {
    position: "sticky",
    top: "180px",
    overflowY: "auto",
    padding: "20px",
    borderRadius: "14px",
    boxShadow: "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": { display: "none" },
  };

  return (
    <>
      <Box sx={{ backgroundColor: "#f4f4f4", minHeight: "100vh" }}>
        <ToastContainer />
        {/* Fixed Search Section */}
        <Paper
          sx={{
            marginTop: "6%",
            padding: "1rem",
            marginBottom: "20px",
            boxShadow: "none",
            backgroundColor: "#0152a9",
            position: "sticky",
            top: 0,
            zIndex: 1000,
          }}
        >
          <Box
            sx={{
              backgroundColor: "white",
              padding: "2rem",
              borderRadius: "8px",
            }}
          >
            <Grid
              container
              spacing={2}
              sx={{ display: "flex", alignItems: "center" }}
            >
              {/* From Station */}
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  options={cities}
                  getOptionLabel={(option) => option.CityName}
                  value={currentFromStation}
                  onInputChange={onInputChange}
                  onChange={(event, newValue) =>
                    setCurrentFromStation(newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="From"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: <DirectionsBusIcon sx={{}} />,
                      }}
                    />
                  )}
                />
              </Grid>

              {/* Flip Icon */}
              <Grid
                item
                xs={12}
                sm={1}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={handleSwapStations}
                  sx={{ backgroundColor: "#1e89fe", color: "white" }}
                >
                  <SwapHorizIcon />
                </IconButton>
              </Grid>

              {/* To Station */}
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  options={cities}
                  getOptionLabel={(option) => option.CityName}
                  value={currentToStation}
                  onInputChange={onInputChange}
                  onChange={(event, newValue) => setCurrentToStation(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="To"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: <LocationOnIcon sx={{}} />,
                      }}
                    />
                  )}
                />
              </Grid>

              {/* Date Picker */}
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Date"
                  type="date"
                  value={currentSelectedDate}
                  onChange={(event) => setCurrentSelectedDate(event.target.value)}
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true, // Prevents label overlap
                  }}
                />
              </Grid>



              {/* Search Button */}
              <Grid item xs={12} sm={2}>
                <Button
                  fullWidth
                  sx={{
                    height: "56px",
                    backgroundColor: "#1e89fe",
                    color: "white",
                    textTransform: "none",
                    fontSize: "18px",
                  }}
                  onClick={searchBuses}
                  disabled={loading || searching}
                >
                  {searching ? (
                    <CircularProgress size={24} sx={{ color: "white" }} />
                  ) : (
                    "Search Bus"
                  )}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Paper>

        {/* Buses Section */}
        <Box sx={{ padding: "20px" }}>
          {/* Buses List */}
          <Grid container spacing={3}>
            {/* Filters Section */}
            <Grid item xs={12} md={3}>
              <Paper sx={filterSectionStyle}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", marginBottom: "10px" }}
                >
                  Filters
                </Typography>
                <Divider />
                <Box sx={{ marginTop: "10px" }}>
                  <Typography variant="subtitle1">Bus Type</Typography>
                  <FormControlLabel control={<Checkbox />} label="AC" />
                  <FormControlLabel control={<Checkbox />} label="Non-AC" />
                  <FormControlLabel control={<Checkbox />} label="Sleeper" />
                  <FormControlLabel control={<Checkbox />} label="Seater" />
                </Box>
                <Box sx={{ marginTop: "20px" }}>
                  <Typography variant="subtitle1">Price Range</Typography>
                  <Slider
                    defaultValue={[300, 5000]}
                    min={300}
                    max={5000}
                    valueLabelDisplay="auto"
                  />
                </Box>
              </Paper>
            </Grid>

            {/* Buses Section */}
            <Grid item xs={12} md={9}>
              {/* Offers Cards */}
              <Paper
                sx={{
                  padding: "20px",
                  borderRadius: "14px",
                  marginBottom: "20px",
                  boxShadow: "none",
                }}
              >
                <Box sx={{ position: "relative" }}>
                  <IconButton
                    sx={{
                      position: "absolute",
                      left: 0,
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 1,
                    }}
                    onClick={() => scrollOffers("left")}
                  >
                    <ArrowLeftIcon />
                  </IconButton>
                  <IconButton
                    sx={{
                      position: "absolute",
                      right: 0,
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 1,
                    }}
                    onClick={() => scrollOffers("right")}
                  >
                    <ArrowRightIcon />
                  </IconButton>
                  <Box
                    ref={offersRef}
                    sx={{
                      overflowX: "auto",
                      whiteSpace: "nowrap",
                      scrollbarWidth: "none",
                      "&::-webkit-scrollbar": { display: "none" },
                    }}
                  >
                    {[1, 2, 3, 4, 5].map((offer, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "inline-block",
                          width: "200px",
                          marginRight: "10px",
                          padding: "10px",
                          backgroundColor: "#f0f0f0",
                          borderRadius: "8px",
                          boxShadow: "none",
                          textAlign: "center",
                        }}
                      >
                        <Typography variant="body1">Offer {offer}</Typography>
                        <Typography variant="body2">Flat 5% Off</Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Paper>

              {/* Scrollable Date Selector */}
              <Paper
                sx={{
                  padding: "20px",
                  borderRadius: "14px",
                  marginBottom: "20px",
                  boxShadow: "none",
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {/* Left Arrow Button */}
                  <IconButton
                    sx={{ position: "static", marginRight: "10px", zIndex: 1 }}
                    onClick={() => scrollDateSelector("left")}
                  >
                    <ArrowLeftIcon />
                  </IconButton>

                  {/* Date Container */}
                  <Box
                    ref={dateSelectorRef}
                    sx={{
                      overflowX: "auto",
                      whiteSpace: "nowrap",
                      scrollbarWidth: "none",
                      "&::-webkit-scrollbar": { display: "none" },
                      flex: 1,
                    }}
                  >
                    {generateDates().map((date, index) => (
                      
                      <Button
                        key={index}
                        variant={
                          date.toDateString() ===
                          new Date(currentSelectedDate).toDateString()
                            ? "contained"
                            : "outlined"
                        }
                        sx={{
                          marginRight: "10px",
                          borderRadius: "14px",
                          backgroundColor:
                            date.toDateString() ===
                            new Date(currentSelectedDate).toDateString()
                              ? "#1e89fe"
                              : "transparent",
                          color:
                            date.toDateString() ===
                            new Date(currentSelectedDate).toDateString()
                              ? "white"
                              : "inherit",
                          "&:hover": {
                            backgroundColor:
                              date.toDateString() ===
                              new Date(currentSelectedDate).toDateString()
                                ? "#1e89fe"
                                : "rgba(0, 0, 0, 0.04)",
                          },
                        }}
                        onClick={() => handleDateChange(date)}
                      >
                        {date.toLocaleDateString("en-US", {
                          weekday: "short",
                          day: "numeric",
                        })}
                      </Button>
                    ))}
                  </Box>

                  {/* Right Arrow Button */}
                  <IconButton
                    sx={{ position: "static", marginLeft: "10px", zIndex: 1 }}
                    onClick={() => scrollDateSelector("right")}
                  >
                    <ArrowRightIcon />
                  </IconButton>
                </Box>
              </Paper>

              <Box
          ref={busesContainerRef}
          sx={{ 
            maxHeight: 'calc(100vh - 300px)', 
            overflowY: 'auto',
            paddingRight: '8px',
            '&::-webkit-scrollbar': {
              width: '6px',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#0152a9',
              borderRadius: '3px',
            }
          }}
        >
          {/* Show loading indicator when changing pages */}
          {isLoading && currentPage === 1 && (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
              <CircularProgress size={24} />
            </Box>
          )}

          {/* Render buses for current page */}
          {buses.map((bus, index) => (
            <Paper
              key={`${bus.ResultIndex}-${index}`}
              sx={{
                padding: "15px",
                marginBottom: "20px",
                borderRadius: "14px",
                boxShadow: "none",
                border: "1px solid #e0e0e0",
                "&:hover": {
                  boxShadow: "0px 2px 18px rgba(0, 0, 0, 0.3)",
                },
              }}
            >
                  <Grid container spacing={2}>
                    {/* Left Sections (1st and 2nd in a single row) */}
                    <Grid item xs={12} md={9.9}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        {/* 1st Section: Travel Name and Bus Type */}
                        <Box>
                          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                            {bus.TravelName}
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{ color: "#666", marginTop: "4px" }}
                          >
                            {bus.BusType}
                          </Typography>
                        </Box>

                        {/* 2nd Section: Origin, Destination, and Journey Duration */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "16px",
                          }}
                        >
                          {/* Origin and Departure Time */}
                          <Box sx={{ textAlign: "center" }}>
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: "bold",
                                color: "#333",
                                fontSize: "16px",
                              }}
                            >
                              {new Date(bus.DepartureTime).toLocaleTimeString(
                                [],
                                { hour: "2-digit", minute: "2-digit" }
                              )}
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                color: "#666",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                            >
                              {origin || Origin}
                            </Typography>
                          </Box>

                          {/* Journey Duration */}
                          <Box sx={{ textAlign: "center" }}>
                            <MultipleStopIcon sx={{ color: "#1e89fe" }} />
                            <Typography
                              variant="body2"
                              sx={{
                                color: "#666",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                            >
                              {calculateJourneyDuration(
                                bus.DepartureTime,
                                bus.ArrivalTime
                              )}
                            </Typography>
                          </Box>

                          {/* Destination and Arrival Time */}
                          <Box sx={{ textAlign: "center" }}>
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: "bold",
                                color: "#333",
                                fontSize: "16px",
                              }}
                            >
                              {new Date(bus.ArrivalTime).toLocaleTimeString(
                                [],
                                { hour: "2-digit", minute: "2-digit" }
                              )}
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                color: "#666",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                            >
                              {destination || Destination}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                      {bus.LiveTrackingAvailable === true && (
                        <Button
                          sx={{
                            textTransform: "none",
                            borderRadius: "18px",
                            color: "black",
                            backgroundColor: "#f5faff",
                            marginTop: "2%",
                          }}
                          startIcon={<GpsFixedIcon />}
                        >
                          Live Tracking
                        </Button>
                      )}
                      {/* Divider */}
                      <Grid item xs={12}>
                        <Divider sx={{ margin: "16px 0" }} />
                      </Grid>

                      {/* 3rd Section: Amenities, Boarding & Dropping Points, Cancellation Policy, Travel Policy */}
                      <Grid item xs={12}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: { xs: "column", sm: "row" },
                            gap: { xs: "8px", sm: "16px" },
                            alignItems: { xs: "flex-start", sm: "center" },
                          }}
                        >
                          {/* Amenities Section */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            {/* Show only 4 icons */}
                            <ElectricalServicesIcon
                              sx={{ fontSize: "16px", color: "#1e89fe" }}
                            />
                            <LogoutIcon
                              sx={{ fontSize: "16px", color: "#1e89fe" }}
                            />
                            <TungstenIcon
                              sx={{ fontSize: "16px", color: "#1e89fe" }}
                            />
                            <MedicalServicesIcon
                              sx={{ fontSize: "16px", color: "#1e89fe" }}
                            />

                            {/* More +1 Button */}
                            <Button
                              size="small"
                              sx={{
                                color: "#1e89fe",
                                fontSize: "12px",
                                textTransform: "none",
                                "&:hover": {
                                  backgroundColor: "#f5faff",
                                },
                              }}
                              onClick={() =>
                                setActiveDropdowns((prev) => ({
                                  ...prev,
                                  [index]:
                                    prev[index] === "amenities"
                                      ? null
                                      : "amenities",
                                }))
                              }
                            >
                              more +1
                            </Button>
                          </Box>

                          {/* Boarding and Dropping Points */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              color:
                                activeDropdowns[index] === "boarding"
                                  ? "#1e89fe"
                                  : "#666",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              setActiveDropdowns((prev) => ({
                                ...prev,
                                [index]:
                                  prev[index] === "boarding"
                                    ? null
                                    : "boarding",
                              }))
                            }
                          >
                            <Typography sx={{ fontSize: "12px" }}>
                              Boarding & Dropping Points
                            </Typography>
                            {activeDropdowns[index] === "boarding" ? (
                              <KeyboardArrowUpIcon />
                            ) : (
                              <KeyboardArrowDownIcon />
                            )}
                          </Box>

                          {/* Cancellation Policy */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              color:
                                activeDropdowns[index] === "cancellation"
                                  ? "#1e89fe"
                                  : "#666",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              setActiveDropdowns((prev) => ({
                                ...prev,
                                [index]:
                                  prev[index] === "cancellation"
                                    ? null
                                    : "cancellation",
                              }))
                            }
                          >
                            <Typography sx={{ fontSize: "12px" }}>
                              Cancellation Policy
                            </Typography>
                            {activeDropdowns[index] === "cancellation" ? (
                              <KeyboardArrowUpIcon />
                            ) : (
                              <KeyboardArrowDownIcon />
                            )}
                          </Box>

                          {/* Travel Policy */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              color:
                                activeDropdowns[index] === "travel"
                                  ? "#1e89fe"
                                  : "#666",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              setActiveDropdowns((prev) => ({
                                ...prev,
                                [index]:
                                  prev[index] === "travel" ? null : "travel",
                              }))
                            }
                          >
                            <Typography sx={{ fontSize: "12px" }}>
                              Travel Policy
                            </Typography>
                            {activeDropdowns[index] === "travel" ? (
                              <KeyboardArrowUpIcon />
                            ) : (
                              <KeyboardArrowDownIcon />
                            )}
                          </Box>
                        </Box>

                        {/* Dropdown for Amenities */}
                        {activeDropdowns[index] === "amenities" && (
                          <Box
                            sx={{
                              marginTop: "8px",
                              padding: "12px",
                              backgroundColor: "#f5faff",
                              borderRadius: "8px",
                              transition: "all 0.3s ease",
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: "bold", color: "#0152a9" }}
                            >
                              Amenities
                            </Typography>
                            <Divider sx={{ margin: "8px 0" }} />
                            <Grid container spacing={2}>
                              {/* Charging Point */}
                              <Grid item xs={6}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <ElectricalServicesIcon
                                    sx={{ color: "#666", fontSize: "16px" }}
                                  />
                                  <Typography
                                    variant="body2"
                                    sx={{ color: "#666" }}
                                  >
                                    Charging Point
                                  </Typography>
                                </Box>
                              </Grid>

                              {/* Emergency Exit */}
                              <Grid item xs={6}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <LogoutIcon
                                    sx={{ color: "#666", fontSize: "16px" }}
                                  />
                                  <Typography
                                    variant="body2"
                                    sx={{ color: "666" }}
                                  >
                                    Emergency Exit
                                  </Typography>
                                </Box>
                              </Grid>

                              {/* Reading Light */}
                              <Grid item xs={6}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <TungstenIcon
                                    sx={{ color: "#666", fontSize: "16px" }}
                                  />
                                  <Typography
                                    variant="body2"
                                    sx={{ color: "#666" }}
                                  >
                                    Reading Light
                                  </Typography>
                                </Box>
                              </Grid>

                              {/* First Aid Box */}
                              <Grid item xs={6}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <MedicalServicesIcon
                                    sx={{ color: "#666", fontSize: "16px" }}
                                  />
                                  <Typography
                                    variant="body2"
                                    sx={{ color: "#666" }}
                                  >
                                    First Aid Box
                                  </Typography>
                                </Box>
                              </Grid>

                              {/* Hammer */}
                              <Grid item xs={6}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <HardwareIcon
                                    sx={{ color: "#666", fontSize: "16px" }}
                                  />
                                  <Typography
                                    variant="body2"
                                    sx={{ color: "#666" }}
                                  >
                                    Hammer
                                  </Typography>
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>
                        )}

                        {/* Dropdown for Boarding and Dropping Points */}
                        {activeDropdowns[index] === "boarding" && (
                          <Box
                            sx={{
                              marginTop: "8px",
                              padding: "12px",
                              backgroundColor: "#f5faff",
                              borderRadius: "8px",
                              transition: "all 0.3s ease",
                              display: "flex",
                              gap: "16px",
                              overflowX: "auto",
                              "&::-webkit-scrollbar": {
                                height: "6px",
                              },
                              "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#0152a9",
                                borderRadius: "3px",
                              },
                            }}
                          >
                            {/* Boarding Points */}
                            <Box
                              sx={{
                                flex: 1,
                                minWidth: "200px",
                                overflowY: "auto",
                                "&::-webkit-scrollbar": {
                                  width: "6px",
                                },
                                "&::-webkit-scrollbar-thumb": {
                                  backgroundColor: "#0152a9",
                                  borderRadius: "3px",
                                },
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: "bold", color: "#0152a9" }}
                              >
                                Boarding Points:
                              </Typography>
                              {/* Divider */}
                              <Grid item xs={12}>
                                <Divider sx={{ margin: "16px 0" }} />
                              </Grid>
                              {bus.BoardingPointsDetails.map((point, idx) => (
                                <Box key={idx} sx={{ marginTop: "4px" }}>
                                  {/* CityPointName in Bold */}
                                  <Typography
                                    variant="body2"
                                    sx={{ fontWeight: "bold", color: "#333" }}
                                  >
                                    {point.CityPointName}
                                  </Typography>
                                  {/* CityPointTime and CityPointLocation below */}
                                  <Typography
                                    variant="body2"
                                    sx={{ color: "#666" }}
                                  >
                                    {new Date(
                                      point.CityPointTime
                                    ).toLocaleTimeString([], {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: false,
                                    })}{" "}
                                    - {point.CityPointLocation}
                                  </Typography>
                                </Box>
                              ))}
                            </Box>

                            {/* Vertical Divider */}
                            <Divider
                              orientation="vertical"
                              flexItem
                              sx={{ borderColor: "#e0e0e0" }}
                            />

                            {/* Dropping Points */}
                            <Box
                              sx={{
                                flex: 1,
                                minWidth: "200px",
                                overflowY: "auto",
                                "&::-webkit-scrollbar": {
                                  width: "6px",
                                },
                                "&::-webkit-scrollbar-thumb": {
                                  backgroundColor: "#0152a9",
                                  borderRadius: "3px",
                                },
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: "bold", color: "#0152a9" }}
                              >
                                Dropping Points:
                              </Typography>
                              <Grid item xs={12}>
                                <Divider sx={{ margin: "16px 0" }} />
                              </Grid>
                              {bus.DroppingPointsDetails.map((point, idx) => {
                                const currentDate = new Date();
                                const pointDate = new Date(point.CityPointTime);
                                const isSameDay =
                                  currentDate.getFullYear() ===
                                    pointDate.getFullYear() &&
                                  currentDate.getMonth() ===
                                    pointDate.getMonth() &&
                                  currentDate.getDate() === pointDate.getDate();

                                return (
                                  <Box key={idx} sx={{ marginTop: "4px" }}>
                                    {/* CityPointName in Bold */}
                                    <Typography
                                      variant="body2"
                                      sx={{ fontWeight: "bold", color: "#333" }}
                                    >
                                      {point.CityPointName}
                                    </Typography>
                                    {/* CityPointTime and CityPointLocation below */}
                                    <Typography
                                      variant="body2"
                                      sx={{ color: "#666" }}
                                    >
                                      {isSameDay
                                        ? pointDate.toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: false,
                                          })
                                        : `${pointDate.toLocaleDateString(
                                            "en-GB",
                                            {
                                              day: "2-digit",
                                              month: "short",
                                              year: "numeric",
                                            }
                                          )} ${pointDate.toLocaleTimeString(
                                            [],
                                            {
                                              hour: "2-digit",
                                              minute: "2-digit",
                                              hour12: false,
                                            }
                                          )}`}{" "}
                                      - {point.CityPointLocation}
                                    </Typography>
                                  </Box>
                                );
                              })}
                            </Box>
                          </Box>
                        )}

                        {/* Dropdown for Cancellation Policy */}
                        {activeDropdowns[index] === "cancellation" && (
                          <Box
                            sx={{
                              marginTop: "8px",
                              padding: "12px",
                              backgroundColor: "#f5faff",
                              borderRadius: "8px",
                              transition: "all 0.3s ease",
                              maxHeight: "200px",
                              overflowY: "auto",
                              "&::-webkit-scrollbar": {
                                width: "6px",
                              },
                              "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#0152a9",
                                borderRadius: "3px",
                              },
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                color: "#0152a9",
                                fontWeight: "bold",
                                marginBottom: "8px",
                              }}
                            >
                              Cancellation Policy
                            </Typography>
                            <Divider sx={{ margin: "16px 0px" }} />

                            <Grid2
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{
                                  color: "#1e89fe",
                                  fontWeight: "bold",
                                  marginBottom: "8px",
                                }}
                              >
                                Cancellation Time
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  color: "#1e89fe",
                                  fontWeight: "bold",
                                  marginBottom: "8px",
                                }}
                              >
                                Refund Amount with Percentage
                              </Typography>
                            </Grid2>
                            {/* Map through CancellationPolicies */}
                            {bus.CancellationPolicies.map((policy, idx) => {
                              const fromDate = new Date(policy.FromDate);
                              const toDate = new Date(policy.ToDate);
                              const refundPercentage =
                                100 - policy.CancellationCharge;

                              return (
                                <Box
                                  key={idx}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom: "12px",
                                  }}
                                >
                                  {/* Cancellation Time */}
                                  <Typography
                                    variant="body2"
                                    sx={{ color: "#666" }}
                                  >
                                    {policy.PolicyString}
                                  </Typography>
                                  {/* Refund Amount with Percentage */}
                                  <Typography
                                    variant="body2"
                                    sx={{ color: "#666" }}
                                  >
                                    Rs{" "}
                                    {Math.floor((refundPercentage / 100) * 559)}{" "}
                                    /- @ {refundPercentage}% refund
                                  </Typography>
                                </Box>
                              );
                            })}
                            {/* Additional Notes */}
                            <Typography
                              variant="body2"
                              sx={{
                                color: "#666",
                                fontStyle: "italic",
                                marginTop: "8px",
                              }}
                            >
                              Refund amount is indicative. Additional Rs. 15 per
                              seat cancellation fee is applicable. Partial
                              cancellation is not allowed.
                            </Typography>
                          </Box>
                        )}

                        {/* Dropdown for Travel Policy */}
                        {activeDropdowns[index] === "travel" && (
                          <Box
                            sx={{
                              marginTop: "8px",
                              padding: "12px",
                              backgroundColor: "#f5faff",
                              borderRadius: "8px",
                              transition: "all 0.3s ease",
                            }}
                          >
                            <Typography variant="body2" sx={{ color: "#666" }}>
                              Travel guidelines and policies apply.
                            </Typography>
                          </Box>
                        )}
                      </Grid>
                    </Grid>
                    <Divider orientation="vertical" flexItem />
                    {/* Right Section: Price and Select Seats Button */}
                    <Grid item xs={12} md={2}>
                      <Box sx={{ textAlign: { xs: "left", md: "right" } }}>
                        <Typography variant="body2" sx={{ color: "#666" }}>
                          Starts at
                        </Typography>
                        <Typography
                          variant="h5"
                          sx={{ fontWeight: "bold", color: "#1e89fe" }}
                        >
                          ₹ {bus.BusPrice.OfferedPriceRoundedOff}
                        </Typography>
                        <Box
                          sx={{
                            backgroundColor: "#aad3fe",
                            borderRadius: "10px",
                            marginTop: "8px",
                          }}
                        >
                          <Grid sx={{ padding: "4px" }}>
                            <Button
                              sx={{
                                backgroundColor: "#1e89fe",
                                color: "white",
                                borderRadius: "6px",
                                textTransform: "none",
                                fontSize: "14px",
                                width: "100%",
                                "&:hover": {
                                  backgroundColor: "#1a73e8",
                                },
                              }}
                              onClick={() =>
                                handleSelectSeats(bus.ResultIndex, index)
                              }
                            >
                              {openSeatLayouts[index]
                                ? "Hide Seats"
                                : "Select Seats"}
                            </Button>
                          </Grid>
                          <Grid sx={{ padding: "4px" }}>
                            <Typography
                              variant="body2"
                              sx={{ fontSize: "12px", textAlign: "center" }}
                            >
                              {bus.AvailableSeats} Seats Available
                            </Typography>
                          </Grid>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                  {openSeatLayouts[index] && (
                    <Box
                      sx={{
                        marginTop: "16px",
                        padding: "16px",
                        borderRadius: "8px",
                      }}
                    >
                      {loading2[index] ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: 100,
                          }}
                        >
                          <CircularProgress size={24} />
                        </Box>
                      ) : (
                        renderSeatSelectionAndPoints(index)
                      )}
                    </Box>
                  )}
                </Paper>
              ))}
                     {isLoading && currentPage > 1 && (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
              <CircularProgress size={24} />
            </Box>
          )}

          {/* Show page information */}
          <Box sx={{ textAlign: 'center', py: 2, color: '#666' }}>
            <Typography variant="body2">
              Page {currentPage} of {totalPages} | {totalItems} buses total
            </Typography>
          </Box>
       


  {/* Message when all buses are loaded */}
  {allBusesLoaded && buses.length > 0 && (
    <Box sx={{ textAlign: 'center', py: 3, color: '#666' }}>
      <Typography>All buses loaded</Typography>
    </Box>
  )}
</Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
    
  );
};

export default BusResults;